<div class="row text-xs-center pt-2 pl-5">
  <div class="col-lg-3 col-md-6 ">
    <span class="colorBox mr-1"></span>
    <h5> <strong>CTR with IVT</strong></h5>
  </div>
  <div class="col-lg-3 col-md-6">
    <span class="colorBox mr-1 mau"></span>
    <h5> <strong>CTR without IVT</strong></h5>
  </div>
</div>
<div class="row pl-5">
  <div class="col-lg-3 col-md-6">
    <h5 *ngIf="!isFreemium">{{data?.ctrDistribution?.ctr | perc:'1.2-2'}} </h5>
    <h5 *ngIf="isFreemium">??</h5>
  </div>
  <div class="col-lg-3 col-md-6">
    <h5 *ngIf="!isFreemium">{{data?.ctrDistribution?.nonGivtSivtCtr | perc:'1.2-2'}}</h5>
    <h5 *ngIf="isFreemium">??</h5>
  </div>
</div>
<div class="row text-xs-center">
  <div class="col-lg-12 col-md-12">
    <ng-container *ngIf="!isFreemium">
      <app-line-chart [data]="lineChartData" [type]="'double'" [valueAxisUnit]="'%'" [height]="'500px'"
        [usePrefixes]="false" [hideLegend]="true" [titleArray]="['CTR with IVT', 'CTR without IVT']"
        [categoryField]="'month'" [valueFields]="['ctr', 'nonGivtSivtCtr']"></app-line-chart>
    </ng-container>
    <ng-container *ngIf="isFreemium">
      <div class="freemium-lock">
        <i class="fa fa-lock"></i>
      </div>
    </ng-container>
  </div>
</div>
<div class="row m-b-1" *ngIf="isFreemium || data?.ctrDistribution && data?.ctrDistribution?.adSizes?.length > 0">
  <div class="col-lg-12 col-md-12">
    <div class="container-fluid">
      <ng-container *ngIf="!isFreemium">
        <app-data-table-component [headers]="headers" [currentSort]="'ctr'" [data]="adSizes" [asc]="true">
        </app-data-table-component>
      </ng-container>
    </div>
  </div>
</div>